import React from 'react';
import { ApiClient } from '@org-avp/avp-hck-dga-customerui-commons';

export const ApiClientContext = React.createContext<ApiClient | undefined>(undefined);

export function useApiClient(): ApiClient {
  const apiClient = React.useContext(ApiClientContext);

  if (!apiClient) {
    throw new Error('No ApiClientContext value was provided.');
  }

  return apiClient;
}
